<template>
  <div id="app">
    <!-- 1. Загрузка -->
    <div v-if="!eventsData" class="home">
      <h1>Система судейства</h1>
      <button @click="fetchData" :disabled="loading">
        {{ loading ? "Загружаем..." : "Получить данные" }}
      </button>
    </div>

    <!-- 2. Список событий -->
    <event-list
      v-else-if="!selectedEvent"
      :data="eventsData"
      @select="selectEvent"
    />

    <!-- 3. Меню события -->
    <event-menu
      v-else-if="!adminMode && !judgeMode && !resultsMode"
      :event-name="selectedEvent"
      :event-data="eventsData[selectedEvent]"
      @back="selectedEvent = null"
      @open-admin="adminMode = true"
      @enter-judge="enterAsJudge"
      @open-results="resultsMode = true"
    />

    <!-- 4. Судейский пульт -->
    <judge-panel
      v-else-if="judgeMode"
      :event-name="selectedEvent"
      :judge-name="selectedJudge"
      @back="judgeMode = false; selectedJudge = null"
    />

    <!-- 5. Экран результатов -->
    <results-panel
      v-else-if="resultsMode"
      :event-name="selectedEvent"
      @back="resultsMode = false"
    />

    <!-- 6. Админка (последняя в цепочке) -->
    <admin-panel
      v-else
      :event-name="selectedEvent"
      :event-data="eventsData[selectedEvent]"
      @back="adminMode = false"
    />
  </div>
</template>

<script>
import EventList from "./components/EventList.vue";
import EventMenu from "./components/EventMenu.vue";
import AdminPanel from "./components/AdminPanel.vue";
import JudgePanel from "./components/JudgePanel.vue";
import ResultsPanel from "./components/ResultsPanel.vue";

export default {
  components: { EventList, EventMenu, AdminPanel, JudgePanel, ResultsPanel },
  data() {
    return {
      loading: false,
      eventsData: null,
      selectedEvent: null,
      adminMode: false,
      judgeMode: false,
      selectedJudge: null,
      resultsMode: false,
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await fetch(
          "https://letsdancescores.tech/danceapi/get-events.php"
        );
        const text = await res.text();
        const clean = text.trim().replace(/^\uFEFF/, "");
        this.eventsData = JSON.parse(clean);
      } catch (err) {
        alert("Ошибка загрузки данных");
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    selectEvent(name) {
      this.selectedEvent = name;
    },
    enterAsJudge(judgeName) {
      this.selectedJudge = judgeName;
      this.judgeMode = true;
    },
  },
};
</script>

<style>
#app {
  min-height: 100vh;
  background: #f5f5f5;
  font-family: Arial, sans-serif;
}
body {
  margin: 0;
}
.home {
  padding: 60px 20px;
  text-align: center;
}
button {
  padding: 16px 32px;
  font-size: 18px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
</style>